import { useEffect, useState } from 'react';
import useAccountApi, { StaticData } from '../../../api/useAccountApi';

export default function useStaticData() {
  const [staticData, setStaticData] = useState<StaticData>({
    industries: [],
    jobTitles: [],
    nationalities: [],
    propertyTypes: [],
    lendingRegions: [],
    countries: [],
    ukCountries: [],
    accountancyQualifications: [],
  });

  const { getStaticData } = useAccountApi();

  useEffect(() => {
    (async () => {
      setStaticData(await getStaticData());
    })();
  }, []);

  return staticData;
}
